const getSafeLocaleData = (activeLocale = 'en-US') => {
  const [language, country] = activeLocale.split('-');
  return { activeLocale, language, country };
};

export default getSafeLocaleData;
